import React from 'react';

interface SuccessMessageProps {
  message: string;
  className?: string;
}

const SuccessMessage: React.FC<SuccessMessageProps> = ({ message, className }) => {
  if (!message) {
    return null;
  }

  return (
    <div className={`bg-green-50 border-l-4 border-green-500 text-green-800 p-6 mb-8 rounded-lg shadow-sm max-w-4xl ${className || ''}`}>
      <div className="flex items-center">
        <svg className="w-6 h-6 mr-3 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
          <path
            fillRule="evenodd"
            d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
            clipRule="evenodd"
          />
        </svg>
        <p className="font-semibold text-lg">{message}</p>
      </div>
    </div>
  );
};

export default SuccessMessage;
